import * as React from 'react';
import Switch from '@mui/material/Switch';
import Typography from "@mui/material/Typography";
import { alpha, styled } from '@mui/material/styles';
import { pink } from '@mui/material/colors';
import useStore from "../../store/store";

const CustomSwitch = styled(Switch)(({ theme, eng }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: pink[600],
        '&:hover': {
            backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: pink[600],
    },
}));

export default function ControlledSwitches({ handleChange }) {

    const eng = useStore((state) => state.eng);

    return (
        <>
            <Typography>Ukr</Typography>
            <CustomSwitch
                eng={eng.toString()}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
            />
            <Typography>Eng</Typography>
        </>
    );
}
